import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { device } from '../../../utils/constants';
import { LabBottomRule, labAos, labBodyMobile } from './labShared';

const LAB_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/img/lab/PLP_LAB_BLANCO.png`;

const Shell = styled.header`
  color: #ffffff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  padding-top: 5vw;

  @media ${device.mobile} {
    min-height: auto;
    min-height: 100svh;
    padding-top: clamp(4rem, 14vw, 6rem);
    padding-bottom: clamp(2rem, 6vw, 3rem);
  }
`;

const TopRow = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: clamp(1rem, 4vw, 3rem);
  font-size: 1.7vw;
  font-family: 'TelegrafLight';
  letter-spacing: 0.02em;
  text-align: center;

  @media ${device.mobile} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem 1.25rem;
    font-size: clamp(0.75rem, 3.2vw, 0.9375rem);
    margin: 0;
    padding: 0 0.5rem;
  }
`;

const CenterBlock = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 8vw 0;

  @media ${device.mobile} {
    padding: clamp(2.5rem, 10vw, 4rem) 0;
  }
`;

const Logo = styled.img`
  width: min(70vw, 500px);
  height: auto;
  display: block;

  @media ${device.mobile} {
    width: min(63vw, 340px);
  }
`;

const TaglinePrimary = styled.p`
  margin: clamp(1.25rem, 3vw, 2rem) 0 0;
  font-weight: 700;
  font-size: 2vw;
  line-height: 1.15;
  font-family: 'TelegrafUltraBold';
  ${labBodyMobile}
`;

const TaglineSecondary = styled.p`
  margin: 0.65rem 0 0;
  font-weight: 400;
  font-size: 2vw;
  line-height: 1.2;
  opacity: 0.95;
  font-family: 'TelegrafRegular';
  ${labBodyMobile}
`;

const BottomBlock = styled.div`
  padding-bottom: clamp(1.25rem, 3vw, 2rem);
`;

const DivisionNote = styled.p`
  margin-top: 2rem;
  margin-bottom: 5vw;
  text-align: center;
  font-weight: 700;
  font-size: 2vw;
  font-family: 'TelegrafUltraBold';
  line-height: 1.2;
  ${labBodyMobile}

  @media ${device.mobile} {
    margin-top: clamp(1.5rem, 5vw, 2rem);
    margin-bottom: clamp(2rem, 6vw, 3rem);
  }
`;

function HeaderLab() {
  const { t } = useTranslation();

  return (
    <Shell>
      <TopRow aria-label="Ubicaciones">
        <span {...labAos('fade-down', 0)}>{t('lab.header.angeles')}</span>
        <span {...labAos('fade-down', 80)}>{t('lab.header.miami')}</span>
        <span {...labAos('fade-down', 160)}>{t('lab.header.mexico')}</span>
        <span {...labAos('fade-down', 240)}>{t('lab.header.venezuela')}</span>
      </TopRow>

      <CenterBlock>
        <Logo {...labAos('zoom-in', 200)} src={LAB_LOGO_SRC} alt="PLP Lab" />
        <TaglinePrimary {...labAos('fade-up', 350)}>
          {t('lab.header.taglinePrimary')}
        </TaglinePrimary>
        <TaglineSecondary {...labAos('fade-up', 450)}>
          {t('lab.header.taglineSecondary')}
        </TaglineSecondary>
      </CenterBlock>

      <BottomBlock>
        <DivisionNote {...labAos('fade-up', 100)}>
          {t('lab.header.divisionNote')}
        </DivisionNote>
        <LabBottomRule aria-hidden />
      </BottomBlock>
    </Shell>
  );
}

export default HeaderLab;
